
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref } from "vue-property-decorator";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import { ILookupItem, LookupItem } from "@/model/LookupItem";
    import ConfirmDialogue from "@/vue/components/ConfirmDialogue.vue";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import { VForm } from "@/vForm";
    import * as toastr from "toastr";
    import { LookupGroup } from "@/model/Enums";

    @Component({ components: { ApiButton, ConfirmDialogue } })
    export default class LookupItemDialogue extends Vue {

        //
        // -- properties
        //

        @Ref("lookupItemForm") private readonly lookupItemForm!: VForm;

        showDialogue: boolean = false;
        dialogueTitle: string = "";
        group: LookupGroup = LookupGroup.All;
        lookupItem: LookupItem = new LookupItem();

        //
        // -- methods
        //

        // called from Lookups.vue
        add(group: LookupGroup): void {
            this.group = group;
            this.reset();
            this.dialogueTitle = "Add Item";
            this.showDialogue = true;
        }

        // called from Lookups.vue
        edit(lookupItemData: ILookupItem): void {
            this.group = lookupItemData.group;
            this.reset();
            this.lookupItem.update(lookupItemData);
            this.dialogueTitle = "Edit Item";
            this.showDialogue = true;
        }

        reset(): void {
            Utils.resetObject(this.lookupItem);
            this.lookupItem.id = 0;
            this.lookupItem.group = this.group;
            this.lookupItemForm?.resetValidation();
        }

        async save(): Promise<void> {
            if (!this.lookupItemForm.validate()) {
                toastr.warning("Please fix highlighted issues", "Cannot Save");
                return;
            }

            await ApiClient.post(`/api/lookup/save/${this.group}`, this.lookupItem, "lookup-save");

            toastr.success("Saved");
            this.$emit("saved");
            this.showDialogue = false;
        }

        confirmDelete(): void {
            const dialog: ConfirmDialogue = this.$refs.deleteDialogue as ConfirmDialogue;
            dialog.show();
        }

        async doDelete(): Promise<void> {
            await ApiClient.post(`/api/lookup/delete/${this.group}`, this.lookupItem, "lookup-delete");
            toastr.warning("Deleted");
            this.$emit("saved");
            this.showDialogue = false;
        }

        restoreCheck(): void {
            const dialog: ConfirmDialogue = this.$refs.restoreDialogue as ConfirmDialogue;
            dialog.show();
        }

        async restore(): Promise<void> {
            await ApiClient.post(`/api/lookup/restore/${this.group}`, this.lookupItem, "lookup-restore");

            toastr.success("Restored");
            this.$emit("saved");
            this.showDialogue = false;
        }

    }
